import styled from "styled-components";

import {
  PopoverWrapper as BasePopoverWrapper,
  PopoverContent as BasePopoverContent,
  CloseButton as BaseCloseButton,
} from "../common/popoverStyles";

export const PopupTipWrapper = styled.a.attrs({
  className: "spf-inline-popup-tip popover-link",
})`
  font-size: inherit;
  text-decoration: none;
  color: #0073ca;
  cursor: pointer;
  display: inline;
  outline: none;

  &:hover {
    opacity: 0.7;
  }

  &:focus,
  &:focus-visible {
    outline: 2px solid #0073ca;
    outline-offset: 2px;
  }

  span {
    text-decoration: underline dotted;
  }
`;

/** Narrower than shared popover on small screens; desktop matches 320px popover. */
export const PopoverWrapper = styled(BasePopoverWrapper)`
  /* Allow ::after arrow (outside box); scrolling stays on PopoverContent */
  overflow: visible !important;
  max-width: min(280px, calc(100vw - 48px));

  @media (min-width: 768px) {
    width: 320px;
    max-width: 320px;
  }

  /*
   * Caret: invert hasYOverflow vs shared PopoverWrapper (see usePopupTip).
   * Single white triangle, pulled slightly into the panel; wrapper box-shadow carries elevation.
   */
  &::after {
    content: "";
    position: absolute;
    width: 0;
    height: 0;
    border-style: solid;
    top: ${(props) => (!props.hasYOverflow ? "-8px" : "unset")};
    bottom: ${(props) => (!props.hasYOverflow ? "unset" : "-8px")};
    left: ${(props) => (props.arrowXOffset ? `${props.arrowXOffset}px` : "50%")};
    transform: ${(props) => (props.arrowXOffset ? "none" : "translateX(-50%)")};
    border-width: ${(props) => (!props.hasYOverflow ? "0 10px 10px 10px" : "10px 10px 0 10px")};
    border-color: ${(props) =>
      !props.hasYOverflow
        ? "transparent transparent var(--popover-surface, #fff) transparent"
        : "var(--popover-surface, #fff) transparent transparent transparent"};
    pointer-events: none;
    z-index: 1;
  }
`;

/** Fixed pixel positioning, flex-centered icon, reliable hover circle. */
export const CloseButton = styled(BaseCloseButton)`
  top: 6px;
  right: 6px;
  margin: 0; /* reset base's margin: 2px 3px */
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background: transparent;
  pointer-events: auto !important;
  z-index: 2;

  &::before {
    top: 0;
    transition: opacity 0.25s ease-out !important;
  }

  &:hover::before {
    /* flat syntax — generates .hash:hover::before correctly */
    opacity: 1;
  }

  &:focus-visible::before {
    /* flat syntax for focus ring */
    opacity: 1;
    outline: 1px auto #669df4;
  }

  svg {
    pointer-events: none;
  }
`;

/** Removes the 940px stage padding and centering so content is left-aligned. */
export const PopoverContent = styled(BasePopoverContent)`
  position: relative;
  z-index: 1;

  .spf-rce-section-content {
    padding: 0 !important;
    align-items: flex-start !important;
  }
`;
